import * as React from 'react';
import { SVGProps } from 'react';

const IcEndurance = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 22.28c-.13 0-.27-.03-.39-.08-8.46-3.55-8.35-11.54-8.35-11.62v-5.2c0-.51.39-.94.9-1 4.85-.53 6.7-1.96 7.15-2.38.38-.36.99-.36 1.37 0 .45.42 2.3 1.85 7.15 2.38.51.06.9.49.9 1v5.22c0 .06.11 8.05-8.34 11.6-.13.05-.26.08-.4.08H12Z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="m17.64 8.01-1.17-.93-5.48 6.84-3.16-3.16-1.06 1.07 4.34 4.34 6.53-8.16Z"
      clipRule="evenodd"
    />
  </svg>
);
export default IcEndurance;
